var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-filetypes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "255px",
    height: "142px",
    viewBox: "0 0 255 142",
    enableBackground: "new 0 0 255 142",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-vector",
    fill: "#E22020",
    d: "M149.688,37.719V17.75l22.188,22.188h-19.969 C150.681,39.938,149.688,38.944,149.688,37.719z M171.875,51.031v68.781c0,2.451-1.986,4.438-4.438,4.438H92 c-2.451,0-4.438-1.986-4.438-4.438V22.188c0-2.451,1.987-4.438,4.438-4.438h46.594c1.226,0,2.219,0.993,2.219,2.219v24.406 c0,2.451,1.986,4.438,4.438,4.438h24.406C170.882,48.813,171.875,49.806,171.875,51.031z M158.563,66.563 c0-2.451-1.986-4.438-4.438-4.438h-17.75c-2.451,0-4.438,1.987-4.438,4.438v12.932l-7.215,5.153c-0.527-0.218-1.09-0.331-1.66-0.335 h-17.75c-2.451,0-4.438,1.986-4.438,4.438v17.75c0,2.451,1.987,4.438,4.438,4.438h17.75c2.451,0,4.438-1.986,4.438-4.438V93.568 l7.215-5.153c0.527,0.218,1.09,0.331,1.66,0.335h17.75c2.451,0,4.438-1.986,4.438-4.438V66.563z M118.625,93.188h-8.875v8.875h8.875 V93.188z M149.688,71h-8.875v8.875h8.875V71z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.03ee50dcb4f14d3d5b555b1c3c4b9fb3.svg";
export { ForwardRef as ReactComponent };